import React from 'react'

const ReservationEmailField = ({
    label = 'E-mailadres',
    required = true,
    value,
    onChange,
    placeholder = '',
    name = 'email'
}) => {
    return (
        <div className="kav-input-field">
            <label className="kav-input-field__label" htmlFor={name}>
                {label}
                {required && <span className="kav-input-field__required">*</span>}
            </label>
            <input
                id={name}
                name={name}
                type="email"
                className="kav-input-field__input"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
            />
        </div>
    )
}

export default ReservationEmailField
